
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ProposalLayer from "../../components/Proposal/ProposalLayer";

const ProposalPage = () => {
    return (
        <>
            <MasterLayout>
                <Breadcrumb title="Proposals" />
                <ProposalLayer />
            </MasterLayout>
        </>
    );
};

export default ProposalPage;
